var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavShowIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "nav-show-icon",
  "data-name": "nav-show-icon",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25 30L23.6 28.6L28.2 24L23.6 19.4L25 18L31 24L25 30ZM17 16H19V32H17L17 16Z",
  fill: "#555"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavShowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav-show-icon.6a4ea33c3519cfa365eb6588c03913e1.svg";